import React from "react";
import "./WebsiteModuleIcon.scss";

export function WebsiteModuleIcon() {
  return (
    <div className="wp-module-icon" aria-hidden="true">
      <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" className="wp-module-icon__svg">
        <rect x="4" y="8" width="44" height="36" rx="6" fill="#fff" stroke="#c7d2fe" strokeWidth="1.5" />
        <rect x="4" y="8" width="44" height="10" rx="6" fill="#f8fafc" />
        <rect x="4" y="14" width="44" height="4" fill="#f8fafc" />
        <circle cx="11" cy="13" r="1.6" fill="#f87171" />
        <circle cx="16.5" cy="13" r="1.6" fill="#fbbf24" />
        <circle cx="22" cy="13" r="1.6" fill="#34d399" />
        <rect x="27" y="11" width="17" height="4" rx="2" fill="#e0e7ff" />
        <rect x="8" y="22" width="36" height="9" rx="3" fill="url(#wpHeroGrad)" />
        <rect x="12" y="25" width="16" height="2" rx="1" fill="rgba(255,255,255,0.9)" />
        <rect x="12" y="28.5" width="10" height="1.5" rx="0.75" fill="rgba(255,255,255,0.55)" />
        <rect x="8" y="34" width="14" height="2" rx="1" fill="#e2e8f0" />
        <rect x="8" y="38" width="20" height="2" rx="1" fill="#f1f5f9" />
        <rect x="30" y="34" width="14" height="6" rx="2" fill="#eef2ff" stroke="#c7d2fe" strokeWidth="1" />
        <rect x="32.5" y="36.5" width="9" height="1.5" rx="0.75" fill="#a5b4fc" />
        <circle cx="40" cy="16" r="7" fill="url(#wpGlobeGrad)" opacity="0.95" />
        <path
          d="M40 11.5c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6.8c-1.5 0-2.8-1.3-2.8-2.8S38.5 12.7 40 12.7s2.8 1.3 2.8 2.8-1.3 2.8-2.8 2.8z"
          fill="#fff"
          opacity="0.95"
        />
        <path d="M36.2 16h7.6M40 12.2v7.6" stroke="#fff" strokeWidth="0.8" strokeLinecap="round" opacity="0.7" />
        <defs>
          <linearGradient id="wpHeroGrad" x1="8" y1="22" x2="44" y2="31" gradientUnits="userSpaceOnUse">
            <stop stopColor="#6366f1" />
            <stop offset="1" stopColor="#8b5cf6" />
          </linearGradient>
          <linearGradient id="wpGlobeGrad" x1="33" y1="9" x2="47" y2="23" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4f46e5" />
            <stop offset="1" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
